import type { IActiveUserSession } from "../ports/outputs/session";
import { RBAC_PERMISSIONS } from "./rbac-permission-codes";
import { sessionHasPermission } from "./session-permissions";

export function canViewDashboardFromSession(
  session: IActiveUserSession | null,
): boolean {
  return sessionHasPermission(session, RBAC_PERMISSIONS.DASHBOARD_VIEW);
}
